import ReactGA from "react-ga4";

export default function GaHandler(category, action, log) {
  console.log(log);
  ReactGA.event({
    category: category,
    action: action,
  });
}